import { useCallback, useEffect, useRef, useState } from 'react';

/** Minimal element-fullscreen hook (replaces @mantine/hooks useFullscreen). */
export function useFullscreen<T extends HTMLElement = HTMLElement>() {
  const [fullscreen, setFullscreen] = useState(false);
  const elRef = useRef<T | null>(null);

  const ref = useCallback((node: T | null) => {
    elRef.current = node;
  }, []);

  useEffect(() => {
    const onChange = () => setFullscreen(document.fullscreenElement === elRef.current);
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);

  const toggle = useCallback(async () => {
    try {
      if (document.fullscreenElement === elRef.current) await document.exitFullscreen();
      else await elRef.current?.requestFullscreen();
    } catch {
      // fullscreen may be blocked (e.g. sandboxed iframe)
    }
  }, []);

  return { ref, toggle, fullscreen };
}
